'use strict'

export function init () {
    if (_config.openModalId) {
        let $modal = $(`#${_config.openModalId}`).first();
        $modal.modal('show');
    }
}
